import React, { Fragment } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { Container } from "reactstrap";

import ConsumerNavbar from "components/Navbars/ConsumerNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import SignUpSidebar from "components/Sidebar/SignUpSidebar.js";

import routes from "routes.js";

class SignUp extends React.Component {
  componentDidUpdate(e) {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.mainContent.scrollTop = 0;
  }
  
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/signup") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  render() {
    return (
      <Fragment>
        {/* <   SignUpSidebar
          {...this.props}
          routes={routes}
          logo={{
            innerLink: "/consumer/index",
            imgSrc: require("assets/img/brand/rae-logo.png"),
            imgAlt: "..."
          }}
        /> */}
        <div className="main-content" ref="mainContent">
          {/* <ConsumerNavbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
          /> */}
          <Switch>
            {this.getRoutes(routes)}
            <Redirect from="*" to="/signup/index" />
          </Switch>
          <Container fluid>
            <AdminFooter />
          </Container>
        </div>
      </Fragment>
    );
  }
}

export default SignUp;
